import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

/**
 * Attempts silent token refresh on app mount when user exists in localStorage
 * but accessToken is missing (e.g., page reload, returning after idle).
 * If refresh fails, clears auth state so ProtectedRoute redirects to /login.
 */
export function AuthInitializer() {
  useEffect(() => {
    const { user, accessToken, setAccessToken, logout } = useAuthStore.getState();

    if (user && !accessToken) {
      fetch(`${API_BASE_URL}/auth/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      })
        .then((res) => {
          if (res.ok) return res.json();
          throw new Error('refresh_failed');
        })
        .then((data) => {
          setAccessToken(data.access_token);
        })
        .catch(() => {
          logout();
        });
    }
  }, []);

  return null;
}
